import PropTypes from 'prop-types';
import EcommerceButtons from './EcommerceButtons';
import { ECOMMERCE_BUTTON_SIZES } from '../../constants';
import { getListingContactData } from '../../utils/hooks';
import {
  extractYachtAndContactsFromListingData,
  extractBrokerDeepLinks
} from '../../utils/transformers';

const EcommerceButtonsWrapper = ({
  parent: { itemId, itemEntity },
  id,
  size,
  buttonText,
  modifier
}) => {
  const data = getListingContactData(itemEntity, itemId);
  if (!data) {
    return null;
  }

  const yachtAndContacts = extractYachtAndContactsFromListingData(itemEntity, data);
  if (!yachtAndContacts) return null;

  const brokerDeepLinks = extractBrokerDeepLinks(data, yachtAndContacts.contacts);
  const thisBrokerDeepLink = brokerDeepLinks.filter(
    brokerDeepLink => brokerDeepLink.brokerId === id
  );

  return (
    <EcommerceButtons
      brokerDeepLinks={thisBrokerDeepLink.length ? thisBrokerDeepLink : brokerDeepLinks}
      contacts={
        thisBrokerDeepLink.length
          ? yachtAndContacts.contacts.filter(contact => contact.brokerId === id)
          : yachtAndContacts.contacts
      }
      data={data}
      size={size}
      yachtData={yachtAndContacts.yachtData}
      buttonText={buttonText}
      modifier={modifier}
    />
  );
};

EcommerceButtonsWrapper.propTypes = {
  id: PropTypes.string,
  parent: PropTypes.object.isRequired,
  size: PropTypes.string,
  buttonText: PropTypes.string,
  modifier: PropTypes.string
};

EcommerceButtonsWrapper.defaultProps = {
  id: '',
  size: ECOMMERCE_BUTTON_SIZES.SIDEBAR,
  buttonText: '',
  modifier: ''
};

export default EcommerceButtonsWrapper;
